import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import AudioRecorder from "./AudioRecorder";

/**
 * Full-page wrapper around AudioRecorder that adds:
 * - A "Recorder" tab (the recording controls)
 * - A "Live Transcript" tab (mirrors transcript from the external popup window)
 * - Scroll support via the page's natural scroll
 *
 * Used for the /audio-recorder route so all roles get the same tab experience
 * as the modal version (AudioRecorderModal) used from the Schedules page.
 */
const AudioRecorderPage = (props) => {
  const [liveTranscriptText, setLiveTranscriptText] = useState("");

  // Primary channel: postMessage from the external recording popup
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "LIVE_TRANSCRIPT_UPDATE") {
        console.log("[AudioRecorderPage] postMessage received:", event.data.text?.slice(0, 60));
        setLiveTranscriptText(event.data.text || "");
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // Fallback channel: localStorage storage event (cross-window)
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "liveTranscriptUpdate" && event.newValue) {
        try {
          const parsed = JSON.parse(event.newValue);
          if (parsed?.text) {
            console.log("[AudioRecorderPage] storage event received:", parsed.text?.slice(0, 60));
            setLiveTranscriptText(parsed.text);
          }
        } catch (_) {}
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  console.log("[AudioRecorderPage] render — liveTranscriptText length:", liveTranscriptText.length);

  return (
    <Box p={4} maxW="800px" mx="auto">
      <Tabs>
        <TabList>
          <Tab>Recorder</Tab>
          <Tab>Live Transcript</Tab>
        </TabList>
        <TabPanels>
          <TabPanel p={0} pt={4}>
            <AudioRecorder {...props} />
          </TabPanel>
          <TabPanel>
            <Box
              p={4}
              bg="gray.50"
              borderRadius="md"
              minH="300px"
              whiteSpace="pre-wrap"
              fontSize="sm"
              color={liveTranscriptText ? "gray.800" : "gray.400"}
            >
              {liveTranscriptText ||
                "Live transcript will appear here once recording starts with live transcription enabled."}
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default AudioRecorderPage;
